import React, { Component } from 'react'
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Spinner from '../common/Spinner';
import { Link } from 'react-router-dom';
import PublicationItem from './components/PublicationItem';
import { CardGroup, Button } from 'semantic-ui-react';
import { getPublications } from '../../actions/publicationActions';
import { isUserLoggedIn } from '../common/isUserLoggedIn';

class Publications extends Component {
  componentDidMount() {
    if (this.props.auth.user.userType === "publisher") {
      this.props.getPublications(this.props.auth.user.id);
    } else {
      if (this.props.auth.user.userType === 'pubadmin') {
        this.props.getPublications(this.props.auth.user.parentPublisher);
      } else {
        window.location.href = "/readers"
      }
    }
  }

  componentWillReceiveProps() {
    isUserLoggedIn();
  }

  render() {
    const { publications, loading } = this.props.publication;
    let publicationItems;

    if (loading) {
      publicationItems = <Spinner />;
    } else {
      if (publications !== null) {
        if (publications.length === 0) {
          publicationItems = (
            <div style={{ margin: "10px" }}>
              <h4>No Publications found for this User</h4>
              <p>To add one, please click the Blue circle to the right</p>
            </div>
          )
        } else {
          if (publications.length > 0) {
            publicationItems = publications.map(publication => (
              <PublicationItem key={publication._id} publication={publication} />
            ));
          }
        }
      }
    }
    return (
      <React.Fragment>
        <Link to="/addpublication">
          <Button circular icon="plus circle" size="massive" color="blue" floated="right" />
        </Link>
        <CardGroup>
          {publicationItems}
        </CardGroup>
      </React.Fragment>
    )
  }
}

Publications.propTypes = {
  getPublications: PropTypes.func.isRequired,
  publication: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  publication: state.publication,
  auth: state.auth
});

export default connect(mapStateToProps, { getPublications })(Publications);